module.exports = __webpack_public_path__ + "static/media/KTN-BNB.b7b9d7dd.svg";